import type { NodeViewProps } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import { useMemo } from 'react';
import { findVariableForChip, formatVariable } from './utils';
import { usePreviewContentVariables } from '../../../../../../providers/PreviewContentVariablesContext.tsx';

export const PreviewContentVariableNodeView = ({ node, getPos, editor }: NodeViewProps) => {
  const { variables } = usePreviewContentVariables();
  const variable = useMemo(
    () =>
      node.attrs.isConflict
        ? undefined
        : findVariableForChip(variables, node.attrs as { name: string; objectId?: string | null; template?: string | null }),
    [variables, node.attrs.name, node.attrs.objectId, node.attrs.template, node.attrs.isConflict]
  );

  const hasInlineValue = node.attrs.value !== null && node.attrs.value !== undefined;

  let valueToRender;
  if (hasInlineValue) {
    valueToRender = String(node.attrs.value);
  } else if (variable) {
    valueToRender = formatVariable(node.attrs.name, variable);
  } else if (variables.length === 0) {
    valueToRender = node.attrs.friendlyName || '';
  } else {
    valueToRender = '';
  }

  const onClick = () => {
    editor.chain().focus().setNodeSelection(getPos()).run();
  };

  return (
    <NodeViewWrapper
      data-type="variable"
      data-name={variable?.name ?? node.attrs.name ?? ''}
      as="span"
      className="tiptap-variable"
      style={{ whiteSpace: 'pre-wrap' }}
      onClick={onClick}
    >
      {valueToRender}
    </NodeViewWrapper>
  );
};
